import { toRaw } from 'vue'

export function isSameRow(
  a: Record<string, unknown> | null | undefined,
  b: Record<string, unknown> | null | undefined
) {
  if (a === b) {
    return true
  }
  if (!a || !b) {
    return false
  }
  const rawA = toRaw(a)
  const rawB = toRaw(b)
  return rawA === rawB || rawA === b || a === rawB
}
